import { render, staticRenderFns } from "./Christmas.vue?vue&type=template&id=1f85b5bc&scoped=true"
import script from "./Christmas.vue?vue&type=script&lang=js"
export * from "./Christmas.vue?vue&type=script&lang=js"
import style0 from "./Christmas.vue?vue&type=style&index=0&id=1f85b5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85b5bc",
  null
  
)

export default component.exports